module.exports = __webpack_public_path__ + "static/media/ic_reset.5a4c3c42.svg";